<template>
    <div>
        <div>
            <form-select id="reg-type" label="Registration Type" :error="msg.type" v-model="localCopy.type" :options="registrationTypes"/>
            
            <div v-if="localCopy.type === 'repair'">
                <form-input id="serial" type="text" label="Serial Number" :error="msg.serial" v-model.trim="localCopy.serial"/>
                <form-input id="fgas" label="FGAS" :error="msg.fgas" v-model="localCopy.fgas"/>
                <form-text-area id="faultDescription" label="Repair Description" :error="msg.faultDetail" v-model="localCopy.faultDetail" />
                <form-text-area id="partUsed" label="Parts Used" :error="msg.notes" v-model="localCopy.notes" />
                <form-toggle id="fittedIn72Hours" label="Fitted within 72 hours" v-model="localCopy.fittedIn72Hours" />
                <form-toggle id="labourAllowanceClaim" label="Claim labour allowance" v-model="localCopy.labourAllowanceClaim" />
            </div>

            <div v-if="localCopy.type ==='warranty' || localCopy.type === 'service'">
                <form-input id="serial" type="text" label="Serial Number" :error="msg.serial" v-model.trim="localCopy.serial"/>
                <form-input id="fgas" label="FGAS" :error="msg.fgas" v-model="localCopy.fgas"/>
            </div>

            <div v-if="localCopy.type ==='part'">
                <form-input id="serial" type="text" label="Serial Number" :error="msg.serial" v-model.trim="localCopy.serial"/>
                <form-input id="partno" type="text" label="Part No" :error="msg.partNo" v-model.trim="localCopy.partNo"/>
                <form-input id="dateSent" type="date" label="Date Sent" :error="msg.partDateSent" v-model.trim="localCopy.partDateSent"/>
                <form-input id="parttype" type="text" label="Part Type" :error="msg.partType" v-model.trim="localCopy.partType"/>
                <form-select id="partsel" label="Purchase / Warranty" :error="msg.partSel" v-model="localCopy.partSel" :options="partSelectTypes"/>
            </div>

            <div v-if="creating" class="flex gap-2 pt-8">
                <custom-button class="flex-grow" type="primary" @click="create">Create</custom-button>
            </div>

        </div>
    </div>
</template>

<script>
import CustomButton from '../../components/CustomButton.vue'
import FormInput from '../../components/FormInput.vue'
import FormSelect from '../../components/FormSelect.vue'
import FormTextArea from '../../components/FormTextArea.vue';
import FormToggle from '../../components/FormToggle.vue'
import _ from 'lodash';
export default {
  components: { FormInput, FormSelect, CustomButton, FormTextArea, FormToggle },
  props: [ 'dataId', 'path', 'creating' ],
  data: function() {
      return {
          backingData: {},
          localCopy: {
              fgas: '',
          },
          changed: false,
          msg: {}
      }
  },
  mounted: async function() {
      if (this.creating) {
          this.localCopy = {
            type:''
          }
      }
      else {
          await this.updateData()
      }
  },
  computed: {
      registrationTypes() {
          return [
              { id: 'warranty', name: 'Warranty' },
              { id: 'service', name: 'Service' },
            //   { id: 'points', name: 'Points Redemption' },
              { id: 'part', name: 'Part Exchanged' },
              { id: 'repair', name: 'Repair Performed'}
          ]
      },
      partSelectTypes() {
        return [
            { id: 'warranty', name: 'Warranty' },
            { id: 'purchase', name: 'Purchase' }
        ]
      },
  },
  methods: {
      updateData: async function() {
        let query = await this.axios.get(this.path + `/${this.dataId}`) 
        this.backingData = query.data
        this.localCopy = Object.assign(Object.create(Object.getPrototypeOf(this.backingData)), this.backingData)
        this.changed = false
      },
      close: function(id) {
        this.$emit('close', id)
      },
      validate: function() {
        this.msg = {}

        var constraints = {
            serial: {
                presence: true,
                length: {
                    minimum: 4
                }
            },
            type: {
                presence: true,
                length: { minimum: 2}
            }
        }

        if (this.localCopy.type === 'part') {
            constraints = { 
                ...constraints,
                partNo: { presence: true, length: { minimum: 1 } },
                partType: { presence: true, length: { minimum: 1 } },
                partDateSent: { presence: true },
                partSel: { presence: true },
            }
        }

        if (this.localCopy.type === 'repair') {
            constraints = {
                ...constraints,
                faultDetail: { presence: true, length: { minimum: 1 }},
                fgas: { presence: true, length: { minimum: 1 }},
                notes: { presence: { message: "^Parts used can't be blank" }, length: { minimum: 1 }}
            }
        }

        this.msg = (this.localCopy.type === 'points' || this.$validate(this.localCopy, constraints)) || {}
        console.log(this.msg)
        return Object.keys(this.msg).length == 0
      },
      create: async function() {
          if (this.validate()) {
              try {
                  let ret = await this.axios.post(this.path + '/create', this.localCopy)
                  this.close(ret.data)
              }
              catch (error) {
                  if (error && error.response && error.response.data && error.response.data.msg) {
                      this.msg = error.response.data.msg
                  }
              }
          }
      },
      save: async function() {
        if (this.validate()) {
            const res = await this.axios.post(this.path + '/update', this.localCopy)
            if (res.status == 200) {
                this.$emit('detailUpdated', this.localCopy)
            }
        }
      }
  },
  updated: function() {
      if (!this.creating) {
        const newVal = !_.isEqual(this.localCopy, this.backingData)
        if (this.changed != newVal) {
            this.changed = newVal;
            this.$emit('detailDirty', newVal)
        }
      }
  }
}
</script>